import React from 'react';
import styled from 'styled-components';

import * as CatizColors from './Colors';

const StyledInput = styled.input`
  background: ${CatizColors.deepBlue};
  color: ${CatizColors.whiteFont};
  text-transform: uppercase;
`;

export default function TextInput(props) {
  return <StyledInput {...props} type="text" />;
}
